import React, { useState, useEffect } from 'react';
import { Grid, FormControlLabel, Switch, Typography } from '@mui/material';

const CustomizationOptions = ({ formData, handleNestedChange }) => {
  const [newVals, setNewVals] = useState(formData.customizationOptions);

  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  const handleDebouncedChange = debounce((name, value) => {
    setNewVals((prevVals) => ({
      ...prevVals,
      [name]: value,
    }));
  }, 3000);

  const handleInputChange = (event) => {
    const { name, checked } = event.target;
    handleNestedChange('customizationOptions', name, checked);
    handleDebouncedChange(name, checked);
  };

  // useEffect(() => {
  //   console.log('New Values:', newVals);
  // }, [newVals]);

  return (
    <>
      <Typography
        variant="h6"
        sx={{ marginTop: 4 }}
      >
        Customization Options
      </Typography>
      <Grid
        container
        spacing={3}
      >
        <Grid
          item
          xs={12}
        >
          <FormControlLabel
            control={
              <Switch
                checked={formData.customizationOptions.useMetricSystem}
                name="useMetricSystem"
                onChange={handleInputChange}
              />
            }
            label="Use Metric System"
          />
        </Grid>
        <Grid
          item
          xs={12}
        >
          <FormControlLabel
            control={
              <Switch
                checked={formData.customizationOptions.showPoweredBy}
                name="showPoweredBy"
                onChange={handleInputChange}
              />
            }
            label="Show ‘Powered by Diet ID’ text below logo"
          />
        </Grid>
        <Grid
          item
          xs={12}
        >
          <FormControlLabel
            control={
              <Switch
                checked={formData.customizationOptions.skipHowItWorks}
                name="skipHowItWorks"
                onChange={handleInputChange}
              />
            }
            label="Skip the How it Works page"
          />
        </Grid>
        <Grid
          item
          xs={12}
        >
          <FormControlLabel
            control={
              <Switch
                checked={formData.customizationOptions.customMealPlans}
                name="customMealPlans"
                onChange={handleInputChange}
              />
            }
            label="Show the Partner’s Custom Meal Plans"
          />
        </Grid>
        <Grid
          item
          xs={12}
        >
          <FormControlLabel
            control={
              <Switch
                checked={formData.customizationOptions.showCODEQ}
                name="showCODEQ"
                onChange={handleInputChange}
              />
            }
            label="Show CODE-Q on Photos for Debugging"
          />
        </Grid>
        <Grid
          item
          xs={12}
        >
          <FormControlLabel
            control={
              <Switch
                checked={formData.customizationOptions.displayDIEMScores}
                name="displayDIEMScores"
                onChange={handleInputChange}
              />
            }
            label="Display DIEM scores in webhooks & exports"
          />
        </Grid>
      </Grid>
    </>
  );
};

export default CustomizationOptions;
